import { useState } from "react";
import HoverDropDown from "./HoverDropDown";
import PCMenuItemTitle from "./PCMenuItemTitle";

interface Props {
  children: any;
  title: {
    Svg?: any;
    url?: string;
    text?: string;
    other?: any;
  };
  down: boolean;
  onSelect?: (e: any) => void;
  reversed?: boolean;
  HoverDropDownCollapseStyle?: React.CSSProperties;
}

const PcDropdown: React.FC<Props> = ({
  children,
  title,
  down = true,
  onSelect,
  reversed = false,
  HoverDropDownCollapseStyle,
}) => {
  const [rotate, setRotate] = useState(false);
  return (
    <HoverDropDown
      onSelect={onSelect}
      title={
        <PCMenuItemTitle
          title={title}
          dropdown
          notMain={!down}
          rotate={rotate}
        />
      }
      down={down}
      setRotate={setRotate}
      reversed={reversed}
      HoverDropDownCollapseStyle={HoverDropDownCollapseStyle}
    >
      {children}
    </HoverDropDown>
  );
};

export default PcDropdown;
